/**
 * Initialise Tako buttons
 */

/* -----------------------------------------------------------------------------
 * Tako Button
 * -------------------------------------------------------------------------- */
import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

const COMPONENT_NAME = 'Button';

export const init = (unresolvedScope: string | Element | unknown) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, { scope });

    const allTakoIconButtons =
        scope.querySelectorAll<HTMLElement>('.tako-button--icon');

    allTakoIconButtons.forEach((iconButton) => {
        try {
            const srContentText =
                iconButton.dataset.srOnlyText ||
                iconButton.getAttribute('aria-label') ||
                iconButton.getAttribute('title');

            if (!srContentText) {
                // Currently no action is taken if there is no accessible text. In the future we need
                // to consider displaying a warning in localdev if the icon-button has no accessible text.
                return;
            }

            // Return if the user has already provided sr-only content
            if (
                iconButton.querySelector('span.sr-only') ||
                iconButton.querySelector('span.tako-sr-only')
            ) {
                return;
            }

            const srContent = document.createElement('span');
            srContent.classList.add('tako-sr-only');
            srContent.innerText = srContentText;
            iconButton.prepend(srContent);
        } catch (error) {
            logger.error(error as string, {
                ...defaultLoggerArgs,
                element: iconButton,
            });
        }
    });
};
